import { Box, Checkbox, CheckGroup, Drawer, IconButton } from 'enova-frontend-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'rooks';

import { CategoryOptions } from '../../../../../../hooks/useBuildingFilter/context';
import { toCamelCase } from '../../../../../../utils/utils';
import useBuildingFilter from '../../../../../../hooks/useBuildingFilter';

export const FilterDrawer = () => {
  const { t } = useTranslation();

  const { allowFilter, categories, filterValues, updateFilterValues, filterVisible, setFilterVisible } =
    useBuildingFilter();

  if (!allowFilter || !categories) {
    return null;
  }

  const updateFilterValuesDebounced = useDebounce<typeof updateFilterValues>(updateFilterValues, 500, {
    leading: true,
    trailing: true
  });

  return (
    <Drawer open={filterVisible} onClose={() => setFilterVisible(false)}>
      <Box p={3}>
        <IconButton icon="close" aria-label={t('close')} onClick={() => setFilterVisible(false)} />
        {filterVisible && (
          <Box display="flex" flexDirection="column">
            {categories.map((category) => (
              <CheckGroup key={category} label={t(category)} marginBottom>
                {CategoryOptions[category].map((option) => (
                  <Checkbox
                    checked={filterValues[category].includes(option)}
                    key={option}
                    label={t(`${category}.${toCamelCase(option)}`)}
                    onChange={(_, checked) => updateFilterValuesDebounced(category, option, checked)}
                    width="fullWidth"
                  />
                ))}
              </CheckGroup>
            ))}
          </Box>
        )}
      </Box>
    </Drawer>
  );
};
